<template>

  <head>

    <meta charset="utf-8" />
    <title>Revenue Team Performance Report | County Management System</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Revenue management system" name="description" />
    <meta content="County Revenue System" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body @contextmenu.prevent data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <div>
                  <h4 class="mb-sm-0 font-size-18">{{formatCategoryName(category)}} Performance Report</h4>
                  <p class="text-muted mb-0">{{formatSubCountyName(subCountyName)}} • Period: {{formatDate(dateFrom)}} to {{formatDate(dateTo)}}</p>
                </div>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Reports</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Revenue by Sub County</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)">{{formatSubCountyName(subCountyName)}}</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Revenue Team</a></li>
                    <li class="breadcrumb-item active">{{formatCategoryName(category)}}</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Team Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-2 col-md-4">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Revenue</span>
                      <h4 class="mb-3">
                        <span class="counter-value text-success">KES {{numberFormat(totalAmountCollected)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-success">
                                                <span class="avatar-title rounded-circle bg-success">
                                                    <i class="bx bx-money font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Team Members</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(revenueTeamLineDetails.length)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-primary">
                                                <span class="avatar-title rounded-circle bg-primary">
                                                    <i class="bx bx-user font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Collections</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(totalCollection)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-info">
                                                <span class="avatar-title rounded-circle bg-info">
                                                    <i class="bx bx-receipt font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Inspections</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(totalInspections)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-warning">
                                                <span class="avatar-title rounded-circle bg-warning">
                                                    <i class="bx bx-search-alt font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Calls</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(totalIncoming + totalOutgoing)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-danger">
                                                <span class="avatar-title rounded-circle bg-danger">
                                                    <i class="bx bx-phone font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Accounts Created</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(totalAccountCreated)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-secondary">
                                                <span class="avatar-title rounded-circle bg-secondary">
                                                    <i class="bx bx-user-plus font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- toolbar start -->
          <SubCountyReportsToolBar/>
          <!-- toobar end -->

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h5 class="card-title mb-0">{{formatCategoryName(category)}} Performance Details</h5>
                      <small class="text-muted">Showing {{revenueTeamLineDetails.length}} team members</small>
                    </div>
                    <div class="col-md-6">
                      <div class="d-flex justify-content-end gap-2">
                        <button @click="refreshData()" type="button" class="btn btn-outline-primary btn-sm" :disabled="loading">
                          <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i>
                          {{ loading ? 'Refreshing...' : 'Refresh' }}
                        </button>
                        <button v-if="getRight('DOWNLOAD REPORTS')" @click="downloadRevenueTeamLineUpDetails()" type="button" class="btn btn-success btn-sm" :disabled="downloading">
                          <i class="bx bx-download"></i> {{download}}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-4">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="searchTerm" type="text" class="form-control" placeholder="Search team members..." />
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex justify-content-end gap-2">
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">From:</label>
                          <input v-model="dateFrom" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">To:</label>
                          <input v-model="dateTo" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body p-0">
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <h5>Loading Team Data...</h5>
                    <p class="text-muted">Please wait while we fetch the {{formatCategoryName(category)}} performance data.</p>
                  </div>

                  <div v-else-if="revenueTeamLineDetails.length === 0" class="text-center py-5">
                    <div class="py-4">
                      <i class="bx bx-user-x font-size-96 text-muted"></i>
                      <h4 class="mt-3">No Team Members Found</h4>
                      <p class="text-muted">No {{formatCategoryName(category)}} found for the selected criteria.</p>
                      <button @click="clearFilters()" class="btn btn-outline-primary">Clear Filters</button>
                    </div>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="table-dark">
                      <tr>
                        <th style="width: 60px;">#</th>
                        <th>{{category}} Details</th>
                        <th class="text-center" style="width: 100px;">Collections</th>
                        <th class="text-center" style="width: 100px;">Inspections</th>
                        <th class="text-center" style="width: 120px;">Calls Made</th>
                        <th class="text-center" style="width: 120px;">Calls Received</th>
                        <th class="text-center" style="width: 120px;">Accounts Created</th>
                        <th class="text-end" style="width: 130px;">Inspection Value</th>
                        <th class="text-end" style="width: 150px;">Amount Collected</th>
                        <th class="text-center" style="width: 120px;">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" :value="item" v-for="(item, index) in revenueTeamLineDetails">
                        <td class="text-center">
                          <span class="badge bg-light text-dark rounded-pill">{{index+1}}</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-sm me-3">
                                                                <span class="avatar-title rounded-circle bg-primary-subtle text-primary">
                                                                    {{getNameInitials(item.names)}}
                                                                </span>
                            </div>
                            <div>
                              <h6 class="mb-1">{{formatName(item.names)}}</h6>
                              <div class="text-muted">
                                <small><i class="bx bx-phone me-1"></i>{{maskPhoneNumber(item.phoneNumber)}}</small>
                                <br>
                                <small><i class="bx bx-envelope me-1"></i>{{item.email || 'N/A'}}</small>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="text-center">
                          <span class="badge bg-info fs-6">{{numberFormat(item.collections)}}</span>
                        </td>
                        <td class="text-center">
                          <span class="badge bg-warning text-dark fs-6">{{numberFormat(item.inspection)}}</span>
                        </td>
                        <td class="text-center">
                          <span class="badge bg-danger fs-6">{{numberFormat(item.outgoing)}}</span>
                        </td>
                        <td class="text-center">
                          <span class="badge bg-secondary fs-6">{{numberFormat(item.incoming)}}</span>
                        </td>
                        <td class="text-center">
                          <span class="badge bg-primary fs-6">{{numberFormat(item.accountsCreated)}}</span>
                        </td>
                        <td class="text-end">
                          <div class="d-flex flex-column align-items-end">
                            <strong class="text-primary">KES {{numberFormat(item.inspectionValue)}}</strong>
                            <small class="text-muted">{{getInspectionPercentage(item.inspectionValue)}}%</small>
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="d-flex flex-column align-items-end">
                            <strong class="text-success">KES {{numberFormat(item.amountCollected)}}</strong>
                            <div class="d-flex align-items-center mt-1" style="width: 100px;">
                              <div class="progress flex-grow-1 me-2" style="height: 6px;">
                                <div class="progress-bar bg-success"
                                     :style="`width: ${getAmountPercentage(item.amountCollected)}%`">
                                </div>
                              </div>
                              <small class="text-muted" style="min-width: 30px;">{{getAmountPercentage(item.amountCollected)}}%</small>
                            </div>
                          </div>
                        </td>
                        <td class="text-center">
                          <button type="button" class="btn btn-primary btn-sm">
                            <i class="bx bx-show me-1"></i> View
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="card-footer bg-light" v-if="revenueTeamLineDetails.length > 0">
                  <!-- Summary Row -->
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>{{numberFormat(revenueTeamLineDetails.length)}} {{formatCategoryName(category)}} Members</strong>
                        </div>
                        <div class="text-end">
                          <div><strong>{{numberFormat(totalCollection)}} Collections</strong></div>
                          <div><strong>{{numberFormat(totalInspections)}} Inspections</strong></div>
                          <div><strong>{{numberFormat(totalAccountCreated)}} Accounts Created</strong></div>
                          <div class="text-primary"><strong>KES {{numberFormat(totalInspectionsValue)}} Inspection Value</strong></div>
                          <div class="text-success"><strong>KES {{numberFormat(totalAmountCollected)}} Total Revenue</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Team Performance Analysis -->
                  <div v-if="revenueTeamLineDetails.length > 0" class="mt-4 pt-3 border-top bg-light">
                    <div class="row">
                      <div class="col-md-6">
                        <h6 class="mb-3 text-primary">
                          <i class="bx bx-trophy me-2"></i>
                          Top 5 Performers
                        </h6>
                        <div v-for="(performer, index) in getTopPerformers()" :key="index" class="mb-3">
                          <div class="d-flex justify-content-between align-items-center mb-1">
                                                        <span class="fw-medium">
                                                            <span class="badge bg-primary me-2">{{ index + 1 }}</span>
                                                            {{ formatName(performer.names) }}
                                                        </span>
                            <strong class="text-success">KES {{ numberFormat(performer.amountCollected) }}</strong>
                          </div>
                          <div class="progress" style="height: 8px;">
                            <div class="progress-bar bg-success"
                                 :style="`width: ${getAmountPercentage(performer.amountCollected)}%`">
                            </div>
                          </div>
                          <small class="text-muted">
                            {{ numberFormat(performer.collections) }} collections • {{ numberFormat(performer.inspection) }} inspections
                          </small>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <h6 class="mb-3 text-info">
                          <i class="bx bx-chart-bar me-2"></i>
                          Team Insights
                        </h6>
                        <ul class="list-unstyled">
                          <li class="mb-2">
                            <i class="bx bx-crown text-warning me-2"></i>
                            Top performer: <strong>{{ getTopPerformer()?.names || 'N/A' }}</strong>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-calculator text-primary me-2"></i>
                            Average revenue per member:
                            <span class="fw-bold">KES {{ getAverageRevenuePerMember() }}</span>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-receipt text-info me-2"></i>
                            Average collections per member:
                            <span class="fw-bold">{{ getAverageCollectionsPerMember() }}</span>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-search-alt text-warning me-2"></i>
                            Average inspections per member:
                            <span class="fw-bold">{{ getAverageInspectionsPerMember() }}</span>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-phone text-danger me-2"></i>
                            Total communication:
                            <span class="fw-bold">{{ numberFormat(totalIncoming + totalOutgoing) }} calls</span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <!-- Performance Distribution -->
                    <div class="row mt-4">
                      <div class="col-12">
                        <h6 class="mb-3">Performance Distribution</h6>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="card text-center border-success">
                              <div class="card-body py-3">
                                <h4 class="text-success mb-1">{{ getHighPerformers().length }}</h4>
                                <p class="mb-0 text-muted">High Performers</p>
                                <small class="text-success">>20% above average</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card text-center border-warning">
                              <div class="card-body py-3">
                                <h4 class="text-warning mb-1">{{ getMediumPerformers().length }}</h4>
                                <p class="mb-0 text-muted">Average Performers</p>
                                <small class="text-warning">Within 20% of average</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card text-center border-danger">
                              <div class="card-body py-3">
                                <h4 class="text-danger mb-1">{{ getLowPerformers().length }}</h4>
                                <p class="mb-0 text-muted">Needs Support</p>
                                <small class="text-danger">Below average performance</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">©County Revenue System</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Developed by County IT Department
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>

  </body>


</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import SubCountyReportsToolBar from "@/components/reports/collectionbysubcounties/SubCountyReportsToolBar";
import {authUrl, biller, execute, executeDownload, getRight} from "@/api";
import moment from 'moment';

export default {
  name: "ReportsSubCountyTeamDetails",
  components: {SubCountyReportsToolBar, NavigationBar},
  data() {
    return {
      download:'Download Report',
      downloading: false,
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems:0,
      subCountyName:'',
      subCountyID:'',
      dateTo:'',
      dateFrom:'',
      names:'',
      totalAmount:null,
      totalAccountCreated: 0,
      totalInspections: 0,
      totalIncoming: 0,
      totalOutgoing: 0,
      totalNumber: 0,
      totalInspectionsValue: 0,
      totalAmountCollected: 0,
      totalCollection: 0,
      category:'',
      searchTerm: '',

      revenueTeamLineDetails: [],
    };
  },
  watch: {
    searchTerm(){
      this.revenueTeamLineUpDetails()
    },

    dateFrom(){
      this.revenueTeamLineUpDetails()
    },

    dateTo(){
      this.revenueTeamLineUpDetails()
    }
  },
  computed:{
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },
  },
  mounted() {
    this.subCountyID = sessionStorage.getItem("subCountyID")
    this.subCountyName = sessionStorage.getItem("subCountyName")
    this.dateTo = sessionStorage.getItem("dateTo")
    this.dateFrom = sessionStorage.getItem("dateFrom")
    this.category = sessionStorage.getItem("role")

    this.revenueTeamLineUpDetails()
    this.menuAccess()
  },
  methods: {

    // Helper methods for better UX
    formatSubCountyName(name) {
      if (!name || name === 'undefined') return 'Unknown';
      return name.toLowerCase().split(' ').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    },

    formatCategoryName(category) {
      if (!category) return 'Team';
      return category.toLowerCase().split(' ').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    },

    formatName(name) {
      if (!name || name === 'undefined') return 'Unknown';
      return name.toLowerCase().split(' ').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    },

    getNameInitials(name) {
      if (!name) return '?';
      return name.split(' ').map(word => word.charAt(0)).join('').substring(0, 2).toUpperCase();
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input;
      }

      const digits = input.replace(/\D/g, '');

      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      return input;
    },

    getAmountPercentage(amount) {
      if (this.totalAmountCollected === 0) return 0;
      return ((Number(amount) / this.totalAmountCollected) * 100).toFixed(1);
    },

    getInspectionPercentage(amount) {
      if (this.totalInspectionsValue === 0) return 0;
      return ((Number(amount) / this.totalInspectionsValue) * 100).toFixed(1);
    },

    getTopPerformers() {
      return [...this.revenueTeamLineDetails]
          .sort((a, b) => Number(b.amountCollected) - Number(a.amountCollected))
          .slice(0, 5);
    },

    getTopPerformer() {
      if (this.revenueTeamLineDetails.length === 0) return null;
      return this.revenueTeamLineDetails.reduce((max, current) =>
          Number(current.amountCollected) > Number(max.amountCollected) ? current : max
      );
    },

    getAverageRevenuePerMember() {
      if (this.revenueTeamLineDetails.length === 0) return '0';
      return this.numberFormat(Math.round(this.totalAmountCollected / this.revenueTeamLineDetails.length));
    },

    getAverageCollectionsPerMember() {
      if (this.revenueTeamLineDetails.length === 0) return '0';
      return this.numberFormat(Math.round(this.totalCollection / this.revenueTeamLineDetails.length));
    },

    getAverageInspectionsPerMember() {
      if (this.revenueTeamLineDetails.length === 0) return '0';
      return this.numberFormat(Math.round(this.totalInspections / this.revenueTeamLineDetails.length));
    },

    getHighPerformers() {
      const average = this.totalAmountCollected / this.revenueTeamLineDetails.length;
      return this.revenueTeamLineDetails.filter(item =>
          Number(item.amountCollected) > (average * 1.2)
      );
    },

    getMediumPerformers() {
      const average = this.totalAmountCollected / this.revenueTeamLineDetails.length;
      return this.revenueTeamLineDetails.filter(item => {
        const amount = Number(item.amountCollected);
        return amount >= (average * 0.8) && amount <= (average * 1.2);
      });
    },

    getLowPerformers() {
      const average = this.totalAmountCollected / this.revenueTeamLineDetails.length;
      return this.revenueTeamLineDetails.filter(item =>
          Number(item.amountCollected) < (average * 0.8)
      );
    },

    refreshData() {
      this.revenueTeamLineUpDetails();
    },

    clearFilters() {
      this.searchTerm = '';
    },

    formatDate(date) {
      if (!date) return '';
      let d = new Date(date);
      let day = d.getDate();
      let month = d.toLocaleString('en-US', { month: 'short' });
      let year = d.getFullYear();

      let suffix = '';
      if (day % 10 === 1 && day !== 11) {
        suffix = 'st';
      } else if (day % 10 === 2 && day !== 12) {
        suffix = 'nd';
      } else if (day % 10 === 3 && day !== 13) {
        suffix = 'rd';
      } else {
        suffix = 'th';
      }
      return `${day}${suffix} ${month} ${year}`;
    },

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Reports Sub County Team Details");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then((res) => {
            // Success
          })
          .catch((e) => {
            console.error("Menu access error:", e);
          });
    },

    getRight(type){
      return getRight(type)
    },

    gotTo(route){
      this.$router.push(route);
    },

    revenueTeamLineUpDetails() {
      this.revenueTeamLineDetails.splice(0)
      this.loading = true

      const data = new FormData();
      data.append("function", "revenueTeamLineUpDetails");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("keyword", this.searchTerm)
      data.append("category",  sessionStorage.getItem("role"))
      data.append("subCountyID", this.subCountyID)

      execute(data, authUrl)
          .then((res) => {
            this.loading = false

            if (res.data.success) {
              this.revenueTeamLineDetails = res.data.data.revenueTeamLineDetails || []

              this.totalCollection = this.revenueTeamLineDetails.reduce((acc, cur) => {
                let total = Number(cur.collections);
                return acc + total;
              }, 0);

              this.totalInspections = this.revenueTeamLineDetails.reduce((acc, cur) => {
                let total = Number(cur.inspection);
                return acc + total;
              }, 0);

              this.totalIncoming = this.revenueTeamLineDetails.reduce((acc, cur) => {
                let total = Number(cur.incoming);
                return acc + total;
              }, 0);

              this.totalOutgoing = this.revenueTeamLineDetails.reduce((acc, cur) => {
                let total = Number(cur.outgoing);
                return acc + total;
              }, 0);

              this.totalNumber = this.revenueTeamLineDetails.reduce((acc, cur) => {
                let total = Number(cur.totalNumber);
                return acc + total;
              }, 0);

              this.totalInspectionsValue = this.revenueTeamLineDetails.reduce((acc, cur) => {
                let total = Number(cur.inspectionValue);
                return acc + total;
              }, 0);

              this.totalAmountCollected = this.revenueTeamLineDetails.reduce((acc, cur) => {
                let total = Number(cur.amountCollected);
                return acc + total;
              }, 0);

              this.totalAccountCreated = this.revenueTeamLineDetails.reduce((acc, cur) => {
                let total = Number(cur.accountsCreated);
                return acc + total;
              }, 0);

            } else {
              console.log("Failed to load team details:", res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error("Error loading team details:", e);
            alert("Failed to load team data. Please check your connection and try again.");
          });
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num || 0)
    },

    downloadRevenueTeamLineUpDetails(){
      this.downloading = true;
      this.download = "Downloading... Please wait"

      const data = new FormData();
      data.append("function", "downloadRevenueTeamLineUpDetails");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("keyword", this.searchTerm)
      data.append("category",  sessionStorage.getItem("role"))
      data.append("subCountyID", this.subCountyID)

      executeDownload(data,authUrl)
          .then(response => {
            this.download = "Download Report"
            this.downloading = false;

            const link = document.createElement('a');
            link.href = URL.createObjectURL(response.data);
            link.download = `${this.dateFrom}_to_${this.dateTo}_${this.formatCategoryName(this.category)}_performance.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(e => {
            this.download = "Download Report"
            this.downloading = false;
            console.error("Download error:", e);
            alert("Failed to download report. Please try again.");
          });
    },
  }
}
</script>

<style scoped>
.card-h-100 {
  height: 100%;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-weight: 600;
}

.bg-primary-subtle {
  background-color: rgba(13, 110, 253, 0.1) !important;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.bx-spin {
  animation: spin 1s linear infinite;
}

.progress {
  background-color: #f3f3f3;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

.badge.fs-6 {
  font-size: 0.875rem !important;
  padding: 0.375rem 0.75rem;
}
</style>